<template>
  <div class="segmentation-text">
    <span v-for="(child, index) in criteriaText" :key="index" @click.stop="signalHelper(index - child.helperLevelsUp)">
      <span v-if="child.textToRender.text" :class="child.textToRender.isLink || child.helperLevelsUp ? 'is-link-enabled' : ''">
        {{ child.textToRender.text }}
      </span>
    </span>
  </div>
</template>

<script>
/* eslint-disable no-template-curly-in-string */
import { mapState, mapActions } from 'vuex'
import { replaceVariables, findReplaceableVariables, variableFormatters } from '@/helpers/replaceVariables'
import { cloneDeep } from 'lodash'

export default {
  props: {
    criteria: {},
    groupIndex: Number,
    criteriaIndex: Number,
  },
  computed: {
    ...mapState({
      selectedCriteria: (state) => state.segmentation.selectedCriteria,
      segmentationGroups: (state) => state.segmentation.segmentationGroups,
      segmentation: (state) => state.segmentation.segmentation,
    }),
    criteriaText() {
      let criteriaToRender = this.criteria
      let currentNode = this.segmentation
      if (this.selectedCriteria && this.groupIndex === this.selectedCriteria.groupIndex && this.criteriaIndex === this.selectedCriteria.criteriaIndex) {
        criteriaToRender = this.selectedCriteria.criteriaValue
      }
      criteriaToRender = criteriaToRender.map((criteria, index) => {
        currentNode = cloneDeep(currentNode?.children?.find((node) => node.id === criteria.id))

        return { textToRender: this.getFormatedText(currentNode, criteria.value), helperLevelsUp: currentNode?.helperLevelsUp || 0 }
      })
      // Skip tab, group and criteria
      return criteriaToRender
    },
  },
  methods: {
    ...mapActions(['selectCriteria']),
    signalHelper(branchIndex) {
      if (!this.selectedCriteria) {
        const currentCriteria = this.segmentationGroups.groups[this.groupIndex].criteria[this.criteriaIndex]
        const tab = this.segmentation.children.find((node) => node.id === currentCriteria[0].id)
        const group = tab.children.find((node) => node.id === currentCriteria[1].id)
        if (!group.requires_pii_access || this.hasPiiAccess) {
          this.selectCriteria({
            groupIndex: this.groupIndex,
            criteriaIndex: this.criteriaIndex,
            newCriteria: false,
          })
        }
      }
      // Wait for the criteria details component to render before sending helper signal
      this.$nextTick(() => this.$bus.$emit('helperSignal', branchIndex))
    },

    getFormatedText(node, value) {
      const replaceableVariables = findReplaceableVariables(node?.text)

      if (!replaceableVariables?.length) {
        return { text: node?.text }
      }
      const formatters = replaceableVariables.reduce((acc, variable) => {
        const cleanVariable = variable.replace(/[^a-zA-Z]/g, '')
        // Skip formatter if it was already resolved
        if (acc[cleanVariable]) return acc
        return { ...acc, [cleanVariable]: variableFormatters[cleanVariable](value) }
      }, {})
      return { text: replaceVariables(node?.text, formatters), isLink: true }
    },
  },
}
</script>

<style lang="scss">
.segmentation-text {
  margin-left: 10px;

  .is-link-enabled {
    margin: 0 2px;
    background-color: $marca-0-l90;
    border: 1px $marca-0-l40 solid;
    border-radius: 5px;
    padding: 2px 4px;
    cursor: pointer;
    user-select: none;
  }

  .is-link-disabled {
    margin: 0 2px;
    background-color: $cinza-l80;
    border: 1px $cinza-l80 solid;
    border-radius: 5px;
    padding: 2px 4px;
    cursor: pointer;
    user-select: none;
  }
}
</style>
